/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { PriceOracle } from '../PriceOracle'

export class PriceOracle__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(overrides?: Overrides): Promise<PriceOracle> {
    return super.deploy(overrides || {}) as Promise<PriceOracle>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PriceOracle {
    return super.attach(address) as PriceOracle
  }
  connect(signer: Signer): PriceOracle__factory {
    return super.connect(signer) as PriceOracle__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceOracle {
    return new Contract(address, _abi, signerOrProvider) as PriceOracle
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'aggregator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'expiry',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256'
      }
    ],
    name: 'ExpiryPriceUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'DISPUTE_PERIOD',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregator',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_expiryTimestamp',
        type: 'uint256'
      }
    ],
    name: 'getExpiryPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isFinalized',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregatorAddress',
        type: 'address'
      },
      {
        internalType: 'uint80',
        name: '_roundId',
        type: 'uint80'
      }
    ],
    name: 'getHistoricalPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregatorAddress',
        type: 'address'
      }
    ],
    name: 'getPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregatorAddress',
        type: 'address'
      }
    ],
    name: 'setAggregator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregator',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_expiryTimestamp',
        type: 'uint256'
      }
    ],
    name: 'setExpiryPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_aggregator',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_expiryTimestamp',
        type: 'uint256'
      },
      {
        internalType: 'uint80',
        name: '_roundId',
        type: 'uint80'
      }
    ],
    name: 'updateExpiryPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'
